const normalizeValue = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

export const normalizeVisitorAuthStatus = (value) => {
  const normalized = normalizeValue(value);
  if (normalized === 'nao autorizado') return 'nao autorizado';
  if (normalized === 'autorizado') return 'autorizado';
  if (normalized === 'sem resposta' || normalized === '') return 'sem resposta';
  return normalized;
};

export const isFamilyVisitorType = (visitor) => {
  const types = Array.isArray(visitor?.type_visitor) ? visitor.type_visitor : [];

  return types.some((type) => {
    const label = type?.name || type?.label || type;
    return normalizeValue(label) === 'familiar';
  });
};

export const getVisitorDisplayStatus = (visitor) => {
  if (!visitor) {
    return { label: '-', className: '', code: 'unknown' };
  }

  const socialStatus = normalizeVisitorAuthStatus(visitor?.social_worker_authorization);
  const isFamily = isFamilyVisitorType(visitor);

  if (!isFamily) {
    if (visitor?.authorize_entry === true) {
      return { label: 'Autorizado', className: 'status-verde', code: 'authorized' };
    }
    return { label: 'Bloqueado', className: 'status-vermelho', code: 'blocked' };
  }

  if (socialStatus === 'nao autorizado') {
    return { label: 'Não autorizado', className: 'status-laranja', code: 'not_authorized' };
  }

  if (socialStatus === 'sem resposta') {
    return { label: 'Pendente', className: 'status-amarelo', code: 'pending' };
  }

  if (socialStatus === 'autorizado') {
    if (visitor?.authorize_entry === false) {
      return { label: 'Bloqueado', className: 'status-vermelho', code: 'blocked' };
    }
    return { label: 'Autorizado', className: 'status-verde', code: 'authorized' };
  }

  if (visitor?.authorize_entry === true) {
    return { label: 'Autorizado', className: 'status-verde', code: 'authorized' };
  }

  return { label: 'Pendente', className: 'status-amarelo', code: 'pending' };
};

